import React, { useState } from 'react';

import { 
  Character,
  BasicCreatureInstance,
  SummonOption2,
  ComplexCreatureInstance
} from "@dndModels";

import CommonUtilities from "@utilities/common_utilities";

import SelectSummonOption2Box from "@dndComponents/select/SelectSummonOption2Box";
import CharacterListOptionsInput from "@dndComponents/character/misc/CharacterListOptionsInput";

interface Props {
  name: string;
  value: SummonOption2 | null;
  character: Character | BasicCreatureInstance | ComplexCreatureInstance;
  shared: boolean;
  summon_option_list: SummonOption2[];
  index?: boolean;
  onChange: (selected: any) => void;
}

const common_util = CommonUtilities.getInstance();

export default function CharacterSummonOptions({
  name,
  value,
  character,
  summon_option_list,
  shared,
  index,
  onChange
}: Props) {
  const [ping, setPing] = useState(false);
  const [change_time, setChangeTime] = useState(0);

  // debugger;
  if (index && character instanceof Character) {
    return (
      <CharacterListOptionsInput 
        data_type="spell"
        character={character}
        use_objects={summon_option_list}
        selected={ value && value.creature ? [value.creature._id] : (value && value.custom_stat_block ? [value.custom_stat_block.true_id] : []) } 
        choose_max={1}
        change_time={change_time}
        onChange={(changed: string[]) => {
          // debugger;
          const id = changed[0];
          const obj_finder = summon_option_list.find(o => o._id === id);
          if (obj_finder) {
            onChange(obj_finder);
            // setPing(!ping);
            setChangeTime(common_util.get_time_number());
          }
        }}
      />
    );
  } else {
    return (
      <SelectSummonOption2Box 
        name={name}
        options={summon_option_list}
        value={ value ? (value.creature ? value.creature._id : value.custom_stat_block?.true_id??null) : null }
        onChange={(changed: string) => {
          const obj_finder = summon_option_list.find(o => o._id === changed);
          if (obj_finder) {
            onChange(obj_finder);
            setPing(!ping);
          }
        }}
      />
    );
  }
}
